import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "./../env";

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

export default function ForgotPassword() {
    const [Email, setEmail] = useState("");
    const [IsLoading, setIsLoading] = useState(false);
    const [complete, setComplete] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        // Check if is Logged in
        let isLocalAuth = localStorage.getItem("pw_user");
        let isSessionAuth = sessionStorage.getItem("pw_user");

        if (isLocalAuth || isSessionAuth) navigate("/");
    }, []);

    const forgotPass = (e) => {
        e.preventDefault();
        if (Email === "") return Toast.fire({ icon: "error", title: "Email required" });
        if (Email.split("@")[1] !== "pw.live") return Toast.fire({ icon: "error", title: "Only pw.live extension is allowed." });

        const params = {
            email: Email
        };

        // converting (json --> form-urlencoded)
        const data = Object.keys(params)
            .map((key) => `${key}=${encodeURIComponent(params[key])}`)
            .join("&");

        setIsLoading(true);
        axios
            .post(BASE_URL + "/admin/forgot-password", data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
            .then((res) => {
                // Validating form
                setIsLoading(false);
                if (res.data.status === "success") {
                    sessionStorage.setItem("pw_email", res.data.email);
                    // console.log(res.data);
                    Toast.fire({ icon: "success", title: `OTP sent to your email.` });
                    navigate("/two-step-verification");
                } else if (res.data.status === "error") Toast.fire({ icon: "error", title: res.data.message });
                else Toast.fire({ icon: "error", title: "Cannot process request" });
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
                Toast.fire({ icon: "error", title: "Please Try Again" });
            });
    };

    return (
        <>
            <div className="row justify-content-center mt-5">
                <div className="col-md-5">
                    <div className="card" style={{ backgroundColor: "#ebebf0", borderRadius: 20, padding: 10 }}>
                        <form className="form-horizontal">
                            <div className="card-body">
                                <div className="form-group row">
                                    <label htmlFor="emailField">Email</label>
                                    <input type="email" className="form-control" id="emailField" placeholder="Enter your Email" value={Email} onChange={(e) => setEmail(e.target.value)} />
                                </div>
                                <div className="form-group row">
                                    <div className="col-6"></div>
                                    <div className="col-6">
                                        <div className="form-check float-right">
                                            <Link to="/sign-in">Sign In</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-dark float-right" onClick={(e) => forgotPass(e)}>
                                            Request OTP
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}
